import React from 'react';
import PropTypes from 'prop-types';
import GreenCheckIcon from '../../../../svg/icons/check.svg';
import './AccountPaymentMethodRow.scss';
import Button from '../../../Button';
import TranslationProvider, { getTranslation } from '../../../../providers/TranslationProvider';
import { isCommonType } from '../../../../utils/paymentMethods';

const normalizeCardType = (type) => {
  const typeMap = {
    'American Express': 'amex',
    MasterCard: 'mastercard',
    Visa: 'visa',
    Discover: 'discover',
    JCB: 'jcb',
  };
  return typeMap[type] || type.toLowerCase().replace(/\s+/g, '');
};

const AccountPaymentMethodRow = ({ paymentMethod, onRemoveCard, onDefaultCard }) => {
  const cardClass = isCommonType(paymentMethod.type)
    ? `AccountPaymentMethodRow__card-icon AccountPaymentMethodRow__icon-${normalizeCardType(paymentMethod.type)}`
    : '';
  return (
    <div className="AccountPaymentMethodRow">
      <div className="AccountPaymentMethodRow__left">
        {cardClass && <div role="img" aria-label={paymentMethod.type} className={cardClass} />}
        {!cardClass && <span aria-live="polite">{normalizeCardType(paymentMethod.type)}</span>}
        <span className="AccountPaymentMethodRow__bullets" aria-hidden="true"> &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; &bull;&bull;&bull;&bull; </span>
        <span>{paymentMethod.display}</span>
      </div>
      {paymentMethod.is_default && (
        <div className="AccountPaymentMethodRow__row">
          <Button
            className="AccountPaymentMethodRow__remove-button"
            onClick={() => onRemoveCard(paymentMethod)}
            aria-label={getTranslation(
              {
                translationKey: 'card_number_announcement_remove',
                translationValues: {
                  type: paymentMethod.type, lastFour: paymentMethod.display,
                },
                fallback: `Remove ${paymentMethod.type} credit card number ending in ${paymentMethod.display}.`,
              }
            )}
            variant="no-style"
          >
            <TranslationProvider translationKey="remove">
              <span>Remove</span>
            </TranslationProvider>
          </Button>
          <div className="AccountPaymentMethodRow__default">
            <TranslationProvider translationKey="default">
              <span>Default</span>
            </TranslationProvider>
            <i className="AccountPaymentMethodRow__green-check-icon">
              <GreenCheckIcon />
            </i>
          </div>
        </div>
      )}
      {!paymentMethod.is_default && (
        <div className="AccountPaymentMethodRow__row">
          <Button
            className="AccountPaymentMethodRow__remove-button"
            onClick={() => onRemoveCard(paymentMethod)}
            aria-label={getTranslation(
              {
                translationKey: 'card_number_announcement_remove',
                translationValues: {
                  type: paymentMethod.type, lastFour: paymentMethod.display,
                },
                fallback: `Remove ${paymentMethod.type} credit card number ending in ${paymentMethod.display}.`,
              }
            )}
            variant="no-style"
          >
            <TranslationProvider translationKey="remove">
              <span>Remove</span>
            </TranslationProvider>
          </Button>
          <Button
            className="AccountPaymentMethodRow__default-button"
            aria-label={getTranslation(
              {
                translationKey: 'card_number_announcement_default',
                translationValues: {
                  type: paymentMethod.type, lastFour: paymentMethod.display,
                },
                fallback: `Make Default - ${paymentMethod.type} credit card number ending in ${paymentMethod.display}.`,
              }
            )}
            onClick={() => onDefaultCard(paymentMethod)}
            variant="no-style"
          >
            <TranslationProvider translationKey="make_default">
              <span>Make Default</span>
            </TranslationProvider>
          </Button>
        </div>
      )}
    </div>
  );
};

AccountPaymentMethodRow.propTypes = {
  paymentMethod: PropTypes.shape({
    type: PropTypes.string,
    is_default: PropTypes.bool,
    display: PropTypes.string,
  }).isRequired,
  onRemoveCard: PropTypes.func.isRequired,
  onDefaultCard: PropTypes.func.isRequired,
};

export default AccountPaymentMethodRow;
